import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import '@fontsource/plus-jakarta-sans/400.css'
import '@fontsource/plus-jakarta-sans/500.css'
import '@fontsource/plus-jakarta-sans/600.css'
import '@fontsource/plus-jakarta-sans/700.css'
import '@fontsource/plus-jakarta-sans/800.css'
import '@fontsource/space-grotesk/300.css'
import '@fontsource/space-grotesk/400.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/600.css'
import '@fontsource/space-grotesk/700.css'
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'
import 'leaflet/dist/leaflet.css'
import './styles/compat.css'
import './styles/tailwind.css'

import { LoadingProvider } from '@frontend-shared/loading'

import App from './App'
import { AuthProvider } from './auth/AuthContext'
import i18n from './i18n'
import ErrorBoundary from './components/ErrorBoundary'
import AppErrorFallback from './components/AppErrorFallback'
import { loadingStore } from './shared/loading/store'
import { captureAppError, initTelemetry } from './telemetry'
import { installVersionWatcher, installVitePreloadRecovery } from '@frontend-shared/assets'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root was not found')
}

installVitePreloadRecovery()
installVersionWatcher()
initTelemetry()

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <LoadingProvider store={loadingStore}>
          <AuthProvider>
            <ErrorBoundary
              onError={(error, info) =>
                captureAppError(error, {
                  feature: 'portal-ui',
                  action: 'render-crash',
                  page: window.location.pathname,
                  component: 'App',
                  componentStack: info.componentStack,
                })
              }
              fallback={({ incidentRef, onReset }: { incidentRef: string | null; onReset: () => void }) => (
                <AppErrorFallback incidentRef={incidentRef} onReset={onReset} />
              )}
            >
              <App />
            </ErrorBoundary>
          </AuthProvider>
        </LoadingProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
)
